import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useAuthentication } from '@aviv-unified-frontend/runtime/authentication';
import { ArrowLeftIcon, ArrowRightIcon } from '@gemini/icons';
import { Button, Modal } from '@gemini/ui';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useCommonPopinUrlPro, usePopinUrl, useShortBrand, } from '@/contexts/brandConfiguration/hooks';
import { redirectTo } from '@/helpers/goTo';
import { useTranslation } from '@/hooks/useTranslations';
import { dispatchRedirectionTracking, trackFurtherRedirection, trackProRedirection, } from '@/tracking';
import { PAGE_CONFIGURATION } from '@/types';
import { signinRedirect } from '@/utils/signinRedirect';
import { DistributionTypeContent } from './DistributionTypeContent';
import { UserContent } from './UserContent';
export const DispatchModal = ({ pageConfiguration, landingType, hasLinkFullWidthResponsive, }) => {
    const methods = useForm();
    const locales = `${pageConfiguration}.${landingType}`;
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [modaleStep, setModaleStep] = useState('first');
    const urlPro = useCommonPopinUrlPro();
    const { state } = useAuthentication();
    const shortBrand = useShortBrand();
    const part = modaleStep === 'first' ? 'user' : 'distributionType';
    const choicesUrl = usePopinUrl(pageConfiguration, landingType);
    const user = methods.watch('user');
    const choiceUserPage = methods.watch('choice');
    const isDisabled = (modaleStep === 'first' && user === undefined) ||
        (modaleStep === 'second' && choiceUserPage === undefined);
    const onPressHandlerPro = () => {
        redirectTo(trackProRedirection(urlPro));
        if (shortBrand == 'IWT' && state !== 'authenticated') {
            signinRedirect({ url: urlPro });
        }
    };
    const onSubmitPage = (choice) => {
        setIsOpen(false);
        redirectTo(dispatchRedirectionTracking(pageConfiguration, landingType, choicesUrl[choice]));
    };
    const onSubmitFsrbo = (choiceUser) => {
        const url = choicesUrl[choiceUser];
        redirectTo(trackFurtherRedirection(url, choiceUser));
    };
    const choicePage = `${pageConfiguration === PAGE_CONFIGURATION.frbo ? 'rent' : 'sale'}`;
    const action = () => {
        const { user, choice: choiceUser } = methods.getValues();
        const actionChoiceFsrbo = () => modaleStep === 'first'
            ? setModaleStep('second')
            : onSubmitFsrbo(choiceUser);
        const actionPrivate = () => pageConfiguration === 'fsrbo'
            ? actionChoiceFsrbo()
            : onSubmitPage(choicePage);
        if (user === 'pro') {
            setIsOpen(false);
            onPressHandlerPro();
        }
        else
            actionPrivate();
    };
    const backAction = () => {
        if (modaleStep === 'second') {
            setModaleStep('first');
        }
        else
            setIsOpen(false);
    };
    return (_jsx(Modal, { title: t(`common.popin.title.${part}`), predefinedWidth: "536", isOpen: isOpen, onOpenChange: () => setIsOpen(false), footerStartButtonProps: {
            children: t(`common.popin.back`),
            icon: ArrowLeftIcon,
            iconPosition: 'start',
            onPress: () => backAction(),
        }, footerEndButtonProps: {
            children: t(`common.popin.continue`),
            onPress: () => action(),
            type: 'button',
            isDisabled,
        }, trigger: () => (_jsx(Button, { variant: "primary", icon: ArrowRightIcon, iconPosition: "end", onPress: () => setIsOpen(true), isFullWidth: hasLinkFullWidthResponsive, children: t(`${locales}.mainButton`) })), children: _createElement(FormProvider, { ...methods, key: "dispatch-modal" },
            modaleStep === 'first' && _jsx(UserContent, {}),
            modaleStep === 'second' && _jsx(DistributionTypeContent, {})) }));
};
